'use strict';

var JAPANESE_PUNCTUATION_MARKS = ['\u2015', '\u3001', '\u3002', '\u300C', '\u300D', '\u300E', '\u300F', '\u3010', '\u3011', '\u301C', '\u30FB', '\uFF01', '\uFF03', '\uFF06', '\uFF08', '\uFF09', '\uFF0C', '\uFF0D', '\uFF1A', '\uFF1F'];

module.exports = {
  JAPANESE_PUNCTUATION_MARKS: JAPANESE_PUNCTUATION_MARKS
};